<template>
  <div
    class="password-recovery-container"
    :class="{ 'change-password' : !!token }"
  >
    <form
      v-if="!isPassSent"
      @submit.prevent="handleSubmit"
      class=" password-recovery-form"
    >
      <template v-if="token && !checkedToken">
        <div class="spinner-container">
          <spinner
            v-if="!errorMsg"
            line-fg-color="#78FAAE"
          />
          <p
            class="error-text"
            v-else
          >
            {{ errorMsg }}
          </p>
        </div>
      </template>
      <template v-else>
        <div
          v-if="errorMsg && errorMsg !== 'Hasła nie są takie same' && errorMsg !== 'Podaj poprawny adres email'"
          class="login-alert-box"
        >
          {{ errorMsg }}
        </div>
        <div class="password-recovery-wrapper">
          <standard-input
            v-if="token"
            type="password"
            :value="repeatInput"
            @input_change="onInput($event, 'repeat')"
            @input_focus="validation = true; errorMsg = ''"
            label="Nowe hasło"
            :valid="errorMsg !== 'Hasła nie są takie same'"
            info="Hasła nie są takie same"
          />
          <standard-input
            v-if="token"
            type="password"
            :value="password"
            @input_change="onInput($event, 'pass')"
            @input_focus="validation = true; errorMsg = ''"
            :valid="errorMsg !== 'Hasła nie są takie same'"
            info="Hasła nie są takie same"
            label="Powtórz hasło"
          />
          <standard-input
            v-else
            type="email"
            :value="email"
            label="Adres email"
            @input_focus="validation = true; errorMsg = ''"
            :valid="errorMsg !== 'Podaj poprawny adres email'"
            info="Podaj poprawny adres email"
            @input_change="onInput($event, 'email')"
          />
          <standard-button
            :text=" token ? 'Zapisz' : 'Przypomnij hasło'"
            type="submit"
            :loading="loading"
            custom-class="pass-recovery-button"
            :background-color="buttonColor"
            :disabled="loading"
          />
        </div>
      </template>
    </form>
    <div
      v-else
      class="pass-sent-info"
    >
      <template v-if="!token">
        <p class="pass-sent-text">
          Na Twój adres e-mail
          <span :style="{ fontWeight: '700'}">
            została wysłana wiadomość
          </span>
          zawierająca link do strony, która umożliwi zmianę hasła. Sprawdź skrzynkę e-mail.
        </p>
        <br>
        <p class="pass-sent-text">
          Uwaga: jeżeli wiadomość nie dotarła sprawdź zakładkę "Spam".
        </p>
      </template>
      <p
        class="pass-sent-text"
        v-else
      >
        Hasło zostało pomyślnie zmienione. Teraz możesz się zalogować.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StandardButton from '~/StandardButton';
import StandardInput from '~/StandardInput';
import ajax from '@/helpers/ajax';
import config from '@/config';
import Spinner from 'vue-simple-spinner';

export default {
  props: {
    token: {
      default: '',
      type: String,
    },
    checkedToken: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    StandardButton,
    StandardInput,
    Spinner,
  },
  data() {
    return {
      email: '',
      password: '',
      repeatInput: '',
      isPassSent: false,
      validation: true,
      errorMsg: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      buttonColor: 'brand/getPrimaryColor',
      thirdColor: 'brand/getThirdColor',
    }),
  },
  methods: {
    ...mapActions({
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
    }),
    onInput(value, input) {
      if (input === 'repeat') {
        this.repeatInput = value;
      } else if (input === 'email') {
        this.email = value;
      } else if (input === 'pass') {
        this.password = value;
      }
    },
    validForm() {
      // eslint-disable-next-line
      const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const passReg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

      if (this.token) {
        if (this.password !== this.repeatInput) {
          this.errorMsg = 'Hasła nie są takie same';
          this.validation = false;
        }
        if (!passReg.test(this.password)) {
          this.errorMsg = 'Hasło musi zawierać minimum 8 znaków, jedną wielką literę, jeden znak specjalny i jedną cyfrę.';
          this.validation = false;
        }
      } else if (!emailReg.test(this.email)) {
        this.validation = false;
        this.errorMsg = 'Podaj poprawny adres email';
      }

      return this.validation;
    },
    handleSubmit() {
      let data;

      if (this.token) {
        data = {
          password: this.password,
          token: this.token,
        };
      } else {
        data = {
          email: this.email,
        };
      }

      if (this.validForm()) {
        const endpoint = this.token ? config.apiEndpoints.changePass : config.apiEndpoints.passRecovery;
        this.loading = true;

        ajax.post(endpoint, data)
          .then((res) => {
            if (res.status === 200) {
              this.isPassSent = true;
            }

            this.loading = false;
          })
          .catch((err) => {
            this.errorMsg = err.response.data.message;
            this.loading = false;
          });
      }
    },
  },
  destroyed() {
    this.$emit('remove_token');
    this.isPassSent = false;
  },
};
</script>
